import {
  Banner,
  Box,
  Grid,
  ReadOnlyField,
  Typography,
} from '@oresundsbron/bridge-ui';
import { Trans, useTranslation } from 'next-i18next';
import { useMemo } from 'react';
import { usePrivateITicketData } from './stores/usePrivateITicketData';

export const Result = () => {
  const { data, response } = usePrivateITicketData();
  const { t } = useTranslation('onlineTicket', {
    nsMode: 'fallback',
  });

  const purchaseInfo = useMemo(() => {
    if (!response || response.tickets.length === 0) return [];
    return [
      {
        label: t('result.labels.orderId'),
        body: response.tickets[0].reference,
      },
      {
        label: t('result.labels.name'),
        body: `${data?.firstName} ${data?.lastName}`,
      },
      { label: t('result.labels.email'), body: data?.email },
      {
        label: t('result.labels.ticketType'),
        body: response.ticketTypeLabel,
      },
      {
        label: t('result.labels.myVehicle'),
        body: data?.licensePlate?.toUpperCase(),
      },
    ];
  }, [data, response, t]);
  return (
    <>
      <Grid className="col-span-full md:col-span-8">
        <Box className="col-span-full">
          <Trans i18nKey="result.description" ns="onlineTicket">
            <Typography intent="title" gutter />
            <Typography intent="label" gutter />
            <Typography intent="label" />
          </Trans>
        </Box>
        <Banner className="col-span-full grid pb-2 sm:grid-cols-2">
          {purchaseInfo
            ? purchaseInfo.map(({ label, body }) => (
                <div className="mb-2" key={label}>
                  <ReadOnlyField label={label}>{body}</ReadOnlyField>
                </div>
              ))
            : null}
        </Banner>
      </Grid>
    </>
  );
};
